import 'twin.macro';
import React from 'react';
import { CJEvent } from '@teetsh/app/src/types/event';
import { OneCard } from './OneCard';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { ClassroomsOrg } from '@teetsh/app/src/types/school';

interface Props {
  event: CJEvent;
  className?: string;
  classroomsOrg: ClassroomsOrg;
  collapsed: boolean;
}

export function Seance({ event, className, classroomsOrg, collapsed }: Props) {
  const user = useUser();

  const { boLabels } = user;
  if (event.type === 'add-event') {
    return null;
  }

  return (
    <div tw="flex flex-1 text-sm" className={className}>
      <OneCard
        collapsed={collapsed}
        classroomsOrg={classroomsOrg}
        boLabels={boLabels}
        condensed={user?.fonts?.cj?.condensed || false}
        event={event}
      />
    </div>
  );
}
